import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import OtpInput from "react-otp-input";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import blueLockIcon from "assets/icons/blueLockIcon.svg";
import eyeIcon from "assets/icons/eye.svg";
import avashologo from "assets/images/logo.svg";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import { FormContainer } from "components/component-styles/alignment";
import FormikControl from "components/form/formikControl";
import Shape from "components/layout/authShapes";
import Users from "services/apis/usersAPI";
import {
  Container,
  HeaderValidation,
  LoginContainer,
  LogoContainer,
  MainContainer,
  RepeatCodeBtn,
  Text,
  TimeContainer,
  ValidationCodeContainer,
} from "./index.styled";
export default function TotalForgotPass() {
  const [code, setCode] = React.useState("");
  const [disable, setDisable] = React.useState(false);
  const [disableOtp, setDisableOtp] = useState(false);
  const mobile = localStorage.getItem("mobile");
  let [sec, setSec] = React.useState(120);

  const [activeBtn, setActiveBtn] = useState(false);

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string().required("رمز عبور الزامی می‌باشد"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), ""],
      "رمزعبور تطابق ندارد"
    ),
  });

  const handleChange = async (code) => {
    setCode(code);
    if (code.length === 5) {
      const response = await new Users({
        mobile,
        code,
        purpose: 'forgetpass'
      }).postVerifyValidationCode();

      if (response.type) {
        // toast.success(response.data?.data);
        setActiveBtn(true);
        toast.success("رمز عبور جدید را وارد کنید.");
        setSec(0);
        setDisableOtp(true);
      } else {
        toast.warning(response.message);
      }
    }
  };

  function convertHMS(value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - hours * 3600) / 60);
    let seconds = sec - hours * 3600 - minutes * 60;
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return minutes + ":" + seconds;
  }

  React.useEffect(() => {
    const countDown = setInterval(() => {
      sec--;
      setSec(() => sec);
      convertHMS(sec);
    }, 1000);
    return () => {
      clearInterval(countDown);
    };
  }, [sec]);

  const [submitOnce, setSubmitOnce] = useState(true);

  const reSendCode = async () => {
    if (submitOnce) {
      setSubmitOnce(false);
      const response = await new Users({ mobile }).postSendValidationCode();
      if (response.type) {
        setSubmitOnce(true);

        setSec(120);

        toast.success(response.data.data);

        setActiveBtn(false);

        setDisableOtp(false);
      } else {
        setSubmitOnce(true);
        toast.warning(response.message);
      }
    }
  };

  const navigate = useNavigate();

  const onSubmit = async (values) => {
    const response = await new Users({
      mobile,
      password: values.password,
    }).postResetPassword();

    if (response.type && response.data.data[0] === 1) {
      toast.success(response.data.data);
      localStorage.removeItem("mobile");
      navigate("/login");
    } else {
      toast.warning(response.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>تغییر رمز عبور</title>
      </Helmet>

      <LoginContainer>
        <LogoContainer color="#89BEFF">
          <div>
            <h2>آواشو</h2>
            <img src={avashologo} alt="logo" />
          </div>
        </LogoContainer>
        <Container>
          <MainContainer>
            <HeaderValidation>وارد کردن کد تایید</HeaderValidation>
            <Text>کد تایید برای شماره موبایل {mobile} ارسال گردید.</Text>
            <OtpInput
              value={code}
              className="otp-input"
              onChange={handleChange}
              numInputs={5}
              separator={<span style={{ width: "8px" }}></span>}
              isInputNum={true}
              shouldAutoFocus={true}
              inputStyle={{
                border: "1px solid #E9EBF8",
                borderRadius: "8px",
                width: "64px",
                height: "64px",
                fontSize: "20px",
                color: "#27548C",
                fontWeight: "500",
                caretColor: "#27548C",
              }}
              focusStyle={{
                border: "1px solid #75A8E8",
                outline: "none",
              }}
            />
            <ValidationCodeContainer>
              <TimeContainer>
                {sec && sec > 0 ? (
                  convertHMS(sec)
                ) : (
                  <RepeatCodeBtn disable={disable} onClick={() => reSendCode()}>
                    ارسال مجدد کد تایید
                  </RepeatCodeBtn>
                )}
              </TimeContainer>
              <Link className="login" to="/login">
                برگشت به صفحه ورود
              </Link>
            </ValidationCodeContainer>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={activeBtn && onSubmit}
              placeholderColor="#2D3134"
              fontColor=""
            >
              {(formik) => {
                return (
                  <FormContainer>
                    <Form>
                      <FormikControl
                        control="input"
                        name="password"
                        type="password"
                        placeholder="رمز عبور"
                        toggleType={true}
                        placeholderColor="#27548C"
                        rightIcon={blueLockIcon}
                        borderColor="#E9EBF8"
                        leftIcon={eyeIcon}
                        fontColor="#27548C"
                        active={activeBtn}
                      />
                      <FormikControl
                        control="input"
                        name="confirmPassword"
                        type="password"
                        placeholder="تکرار رمز عبور"
                        toggleType={true}
                        placeholderColor="#27548C"
                        rightIcon={blueLockIcon}
                        borderColor="#E9EBF8"
                        leftIcon={eyeIcon}
                        fontColor="#27548C"
                        active={activeBtn}
                      />
                      <CustomButton
                        width="400px"
                        color="#fff"
                        height="56px"
                        radius="12px"
                        width360="320px"
                        width417="328px"
                        borderColor="#6CAEFF"
                        background="#6CAEFF"
                        backgroundHover="#FFF"
                        borderColorHover="#6CAEFF"
                        colorHover="#6CAEFF"
                        type="submit"
                        className={!activeBtn && "disabled"}
                      >
                        ورود
                      </CustomButton>
                    </Form>
                  </FormContainer>
                );
              }}
            </Formik>
          </MainContainer>
          <Shape />
        </Container>
      </LoginContainer>
    </>
  );
}
